// src/components/chat/sections/combineWithMine/ComingSoonDisplay.js
import React from 'react';
import upload from '../combineWithMine/upload.png';
import analysis from '../combineWithMine/analysis.png';
import selection from '../combineWithMine/selection.png';
import result from '../combineWithMine/result.png';

const ComingSoonDisplay = () => {
    return (
        <div className="coming-soon-container">
            <div className="coming-soon-header">
                <div className="coming-soon-badge">Coming Soon</div>
                <h2>Combine with Mine</h2>
                <p className="coming-soon-subtitle">
                    We're working on making this feature available soon. Stay tuned!
                </p>
            </div>

            <div className="feature-description">
                <h3>How it will work:</h3>
                <div className="feature-steps">
                    <div className="feature-step">
                        <div className="step-number">1</div>
                        <div className="step-content">
                            <h4>Upload your photo</h4>
                            <p>Upload a photo of yourself or your current outfit</p>
                            <div className="step-image-container">
                                <img 
                                    src={upload}
                                    alt="Upload your photo" 
                                    className="step-image"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="feature-step">
                        <div className="step-number">2</div>
                        <div className="step-content">
                            <h4>AI Analysis</h4>
                            <p>Our AI analyzes your outfit and identifies each item</p>
                            <div className="step-image-container">
                                <img 
                                    src={analysis} 
                                    alt="AI analyzes your outfit" 
                                    className="step-image"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="feature-step">
                        <div className="step-number">3</div>
                        <div className="step-content">
                            <h4>Choose what to replace</h4>
                            <p>Select the item of clothing you'd like to replace</p>
                            <div className="step-image-container">
                                <img 
                                    src={selection}
                                    alt="Choose what to replace" 
                                    className="step-image"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="feature-step">
                        <div className="step-number">4</div>
                        <div className="step-content">
                            <h4>See the result</h4>
                            <p>Get a visualization of your outfit with the new item and links to purchase it</p>
                            <div className="step-image-container">
                                <img 
                                    src={result}
                                    alt="See the result" 
                                    className="step-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="beta-signup-section">
                <h3>Want to try it first?</h3>
                <p>Join our beta testers to get early access to this feature. Coming very soon!</p>
                <a 
                    href="https://forms.gle/styleForecastBeta" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="beta-signup-button"
                >
                    Sign up for beta testing
                </a>
            </div>
        </div>
    );
};

export default ComingSoonDisplay;